module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/codigos/codigos.component.scss
// module id = ./src/app/pages/codigos/codigos.component.scss
// module chunks = main